//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

import { hasFeature } from 'app/initialization/routing/stateHelpers';

export const getIsCampaignContentApprovalEnabled = createHasFeatureSelector(
  FeatureNames.CreatorCampaignsContentApproval,
);

export const hasFeatureContentApproval = () =>
  hasFeature(FeatureNames.CreatorCampaignsContentApproval);
